// Author Eric
// Date 2020-09-18 10:53:22

class SithMesAndonType {
constructor({
        id = null,
        parentId = '',
        name = '',
        remark = ''}
= {}) {
    this.id = id;
    this.parentId = parentId;
    this.name = name;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesAndonType();
}

function gridFields() {
return Object.freeze([
        {
        key: 'parentName',
        label: 'label.sith.andon.sithMesAndonType.grid.parentName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.andon.sithMesAndonType.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.sith.andon.sithMesAndonType.grid.level',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.sith.andon.sithMesAndonType.grid.nodeCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.andon.sithMesAndonType.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
]);
}

const filter = {
    parentIdFilter : "",
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'parentIdFilter',
        label: 'label.sith.andon.sithMesAndonType.filter.parentId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.sith.andon.sithMesAndonType.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'parentId',
        label: 'label.sith.andon.sithMesAndonType.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesAndonType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'name',
        label: 'label.sith.andon.sithMesAndonType.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.andon.sithMesAndonType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesAndonType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
